function Button (
    {
        type = "button",
        text = "Button",
        onClick = () => {},
        disabled = false,
        style = "default"
    }
) {
  return (
    <div className='button-box'>
      <button className={`button ${style}`} type={type} onClick={onClick} disabled={disabled}>
        <span className='btn-text'>{text}</span>
      </button>
    </div>
  )
}

export default Button;
